import * as React from "react"

function User(props) {
  return (
    <svg
      width={18}
      height={18}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 16.5a7.5 7.5 0 110-15 7.5 7.5 0 010 15zm5.045-4.006a6.136 6.136 0 10-10.09 0c.767-1.014 2.57-1.448 5.045-1.448s4.278.434 5.045 1.448zm-.978 1.101c-.2-.717-1.633-1.186-4.067-1.186s-3.867.469-4.067 1.186A6.113 6.113 0 009 15.136c1.56 0 2.984-.582 4.067-1.54zM9 4.91c-1.65 0-2.727 1.197-2.727 2.727 0 2.337 1.2 3.41 2.727 3.41 1.512 0 2.727-1.037 2.727-3.273 0-1.554-1.081-2.864-2.727-2.864zM7.636 7.636c0 1.548.558 2.046 1.364 2.046.803 0 1.364-.479 1.364-1.91 0-.851-.535-1.5-1.364-1.5-.863 0-1.364.557-1.364 1.364z"
        fill="#000"
      />
    </svg>
  )
}

export default User
